import React from 'react';
import { Modal } from './ui.jsx';
import { CHANGELOG } from '../data/changelog.js';

export function WhatsNewModal({ onClose }) {
  return (
    <Modal title="What's new" onClose={onClose}>
      <div className="changelog">
        {CHANGELOG.map((entry) => (
          <div className="changelog-entry" key={entry.date}>
            <div className="changelog-date">{entry.date}</div>
            <ul>
              {entry.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Modal>
  );
}
